<template>
  <div class="wce-multi-region">
    <el-select v-model="regionPro" placeholder="请选择省" class="selectStatus" @change="regionProChange" v-if="regionsShow.province">
      <el-option v-for="item in regionProList" :key="item.code" :label="item.name" :value="item.code"> </el-option>
    </el-select>
    <el-select
      v-model="regionCity"
      placeholder="请选择市"
      class="selectStatus"
      @change="regionCityChange"
      v-if="regionsShow.city"
      :clearable="regionsClearable.city">
      <el-option v-for="item in regionCityList" :key="item.code" :label="item.name" :value="item.code"> </el-option>
    </el-select>
    <el-select
      v-model="regionCounty"
      placeholder="请选择县/区"
      class="selectStatus"
      @change="regionCountyChange"
      v-if="regionsShow.county"
      :clearable="regionsClearable.county">
      <el-option v-for="item in regionCountyList" :key="item.code" :label="item.name" :value="item.code"> </el-option>
    </el-select>
  </div>
</template>
<script>
import PCAA from "area-data/pcaa";

export default {
  name: "WceMultiRegion",
  components: {},
  props: {
    regionInfoCode: {
      //默认值
      type: Object,
      default() {
        return {};
      },
    },
    regionsShow: {
      //地区展示
      type: Object,
      default() {
        return {
          province: true,
          city: true,
          county: true,
        };
      },
    },
    regionsClearable: {
      type: Object,
      default() {
        return {
          city: false,
          county: false,
        };
      },
    },
    isAll: {
      //是否有全国（县）选项
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      PCAA: PCAA,
      regionPro: "000000", //350000
      regionCity: "",
      regionCounty: "",
      regionProList: [],
      regionCityList: [],
      regionCountyList: [],
      regionInfo: {
        regionPro: "000000", //350000
        regionCity: "",
        regionCounty: "",
      },
      defaultInfo: {
        regionPro: "", //350000
        regionCity: "",
        regionCounty: "",
      },
    };
  },
  created: function () {
    this.getRegionPro();
  },
  mounted() {},
  watch: {
    regionInfoCode: {
      handler() {
        if (this.regionInfoCode.regionPro) {
          this.setDefaultRegion(this.regionInfoCode);
          if (this.regionInfoCode.regionCity) {
            this.regionCityChange();
          }
        }
      },
      immediate: true,
    },
  },
  methods: {
    //省份的数组对应
    getRegionPro() {
      var that = this,
        item = {},
        regionProList = [];
      if (this.isAll) {
        let national = {
          code: "000000",
          name: "全国",
        };
        regionProList.push(national);
      }
      var list = {
        code: "",
        name: "",
      };
      var item = that.PCAA[86];
      // console.log(that.PCAA);
      for (var key in that.PCAA[86]) {
        list = {
          code: "",
          name: "",
        };
        list.code = key;
        list.name = item[key];
        regionProList.push(list);
      }
      that.regionProList = regionProList;
      if (that.regionPro != "") {
        that.regionProChange();
      }
      that.regionData();
    },
    //省份的选择
    regionProChange() {
      var that = this,
        item = {},
        regionCityList = [];
      if (that.regionPro != "000000") {
        if (this.isAll) {
          let allProvince = {
            code: "000000",
            name: "全省",
          };
          regionCityList.push(allProvince);
        }
        var list = {
          code: "",
          name: "",
        };
        if (that.defaultInfo.regionCity == "") {
          that.regionCity = "";
        }
        var item = that.PCAA[that.regionPro];
        for (var key in item) {
          list = {
            code: "",
            name: "",
          };
          list.code = key;
          list.name = item[key];
          regionCityList.push(list);
        }
        that.regionCityList = regionCityList;
      } else {
        that.regionCityList = [];
        that.regionCity = "";
        that.regionCountyList = [];
        that.regionCounty = "";
      }
      that.regionData();
    },
    //市份的选择
    regionCityChange() {
      var that = this,
        item = {},
        regionCountyList = [];
      if (that.regionCity != "000000" && that.regionCity != "") {
        if (this.isAll) {
          let allCity = {
            code: "000000",
            name: "全市",
          };
          regionCountyList.push(allCity);
        }
        var list = {
          code: "",
          name: "",
        };
        if (that.defaultInfo.regionCounty == "") {
          that.regionCounty = "";
        }
        var item = that.PCAA[that.regionCity];
        for (var key in item) {
          list = {
            code: "",
            name: "",
          };
          list.code = key;
          list.name = item[key];
          regionCountyList.push(list);
        }
        that.regionCountyList = regionCountyList;
      } else {
        that.regionCountyList = [];
        that.regionCounty = "";
      }
      that.regionData();
    },
    //区的选择
    regionCountyChange() {
      var that = this;
      that.regionData();
    },
    //地区值的传递
    regionData() {
      var that = this;
      if (that.regionPro == "000000") {
        that.regionInfo = {
          regionPro: "", //全国
          regionCity: "",
          regionCounty: "",
        };
      } else {
        that.regionInfoCode.regionPro = that.regionPro;
        that.regionInfoCode.regionCity = that.regionCity;
        that.regionInfoCode.regionCounty = that.regionCounty;
        if (that.regionPro != "") {
          that.regionInfo.regionPro = that.PCAA[86][that.regionPro] || "";
        }
        if (that.regionCity != "") {
          that.regionInfo.regionCity = that.PCAA[that.regionPro][that.regionCity] || "";
        }
        if (that.regionCounty != "") {
          that.regionInfo.regionCounty = that.PCAA[that.regionCity][that.regionCounty] || "";
        } else {
          that.regionInfo.regionCounty = "";
        }
      }
      that.$emit("regionInfo", that.regionInfo);
    },
    //常用地区点击的方法
    setDefaultRegion(defaultRegionInfo) {
      this.defaultInfo = defaultRegionInfo;
      this.regionPro = defaultRegionInfo.regionPro || "000000";
      this.regionCity = defaultRegionInfo.regionCity || "";
      this.regionCounty = defaultRegionInfo.regionCounty || "";
      this.getRegionPro();
    },
  },
};
</script>
<style lang="scss" scoped>
.wce-multi-region {
  display: inline;
  text-align: left;
  .selectStatus {
    width: 160px;
    margin: 0 5px;
  }
  .select {
    text-indent: 0px !important;
  }
}
</style>
